// Multilingual dictionaries: IT (default), EN, DE
export const translations = {
  it: {
    nav: {
      services: "Servizi",
      process: "Processo",
      work: "Cosa creiamo",
      about: "Chi siamo",
      contact: "Contatti",
      cta: "Richiedi preventivo",
    },
    hero: {
      eyebrow: "AGENZIA DI WEB DESIGN · INNOVATE YOUR FUTURE",
      titleLine1: "Costruiamo",
      titleLine2: "esperienze digitali",
      titleLine3: "che contano.",
      subtitle:
        "DeFalco WebSolution trasforma idee in siti web eleganti, veloci e pensati per far crescere il tuo brand. Design su misura, codice pulito, attenzione ai dettagli.",
      primaryCta: "Iniziamo il tuo progetto",
      secondaryCta: "Scopri i servizi",
      scrollHint: "Scorri per esplorare",
      pillarsTitle: "Il nostro approccio",
      pillars: [
        { label: "Design su misura", desc: "Niente template, solo soluzioni pensate per te." },
        { label: "Codice pulito", desc: "Veloce, sicuro, mantenibile." },
        { label: "Supporto reale", desc: "Comunicazione diretta e continua." },
      ],
      tagsBelow: ["Multilingue", "Responsive", "SEO-friendly"],
    },
    marquee: [
      "WEB DESIGN",
      "SVILUPPO",
      "E-COMMERCE",
      "SEO",
      "BRANDING",
      "MANUTENZIONE",
      "STRATEGIA",
      "UX/UI",
    ],
    stack: {
      eyebrow: "IL NOSTRO STACK",
      title: "Tecnologie moderne, risultati duraturi.",
      body:
        "Lavoriamo con strumenti collaudati e best practice diffuse nel settore per garantire velocità, sicurezza e scalabilità.",
      groups: [
        { label: "Front-end", items: ["React", "Next.js", "Tailwind CSS", "Framer Motion"] },
        { label: "Back-end", items: ["Node.js", "FastAPI", "MongoDB", "PostgreSQL"] },
        { label: "Piattaforme", items: ["WordPress", "Shopify", "Webflow", "Sanity CMS"] },
        { label: "Qualità", items: ["Web Vitals", "SEO Tecnico", "GDPR", "Accessibilità AA"] },
      ],
    },
    services: {
      eyebrow: "COSA FACCIAMO",
      title: "Servizi pensati per far crescere il tuo business.",
      items: {
        webdesign: {
          title: "Web Design",
          description:
            "Interfacce eleganti e intuitive, pensate per convertire visitatori in clienti.",
        },
        development: {
          title: "Sviluppo Web",
          description:
            "Siti veloci, sicuri e scalabili costruiti con tecnologie moderne.",
        },
        ecommerce: {
          title: "E-commerce",
          description:
            "Shop online performanti per vendere ovunque, 24 ore su 24.",
        },
        seo: {
          title: "SEO",
          description:
            "Lavoriamo l'ottimizzazione tecnica e i contenuti per migliorare la tua visibilità su Google.",
        },
        branding: {
          title: "Branding",
          description:
            "Identità visive coerenti che raccontano chi sei e cosa fai.",
        },
        maintenance: {
          title: "Manutenzione",
          description:
            "Aggiornamenti, backup e supporto continuo per dormire sereno.",
        },
      },
    },
    process: {
      eyebrow: "COME LAVORIAMO",
      title: "Un processo chiaro, dal primo click alla pubblicazione.",
      steps: [
        {
          title: "Ascolto",
          description:
            "Capiamo i tuoi obiettivi, il pubblico e il posizionamento del brand.",
        },
        {
          title: "Strategia",
          description:
            "Definiamo architettura, contenuti e identità in un piano concreto.",
        },
        {
          title: "Design",
          description:
            "Prototipi interattivi che rispecchiano la tua personalità digitale.",
        },
        {
          title: "Sviluppo",
          description:
            "Costruiamo il sito con codice pulito, performante e accessibile.",
        },
        {
          title: "Lancio & Crescita",
          description:
            "Pubblichiamo, misuriamo, ottimizziamo. Il lancio è solo l'inizio.",
        },
      ],
    },
    work: {
      eyebrow: "COSA POSSIAMO COSTRUIRE",
      title: "Le tipologie di siti che realizziamo.",
      items: [
        {
          tag: "E-COMMERCE",
          name: "Negozi online",
          desc: "Shop multilingua e multi-valuta, integrazioni con corrieri e pagamenti.",
        },
        {
          tag: "CORPORATE",
          name: "Siti aziendali",
          desc: "Presentazione professionale, sezione team, area news, lead generation.",
        },
        {
          tag: "PORTFOLIO",
          name: "Portfolio creativi",
          desc: "Per fotografi, designer, studi creativi che vogliono distinguersi.",
        },
        {
          tag: "WEB APP",
          name: "Applicazioni su misura",
          desc: "Dashboard, gestionali, piattaforme SaaS, automazioni.",
        },
      ],
      viewAll: "Parliamone",
    },
    why: {
      eyebrow: "I NOSTRI VALORI",
      title: "Partner digitali, non semplici fornitori.",
      body:
        "Lavoriamo a stretto contatto con ogni cliente. Trasparenza, cura dei dettagli e attenzione reale sono il nostro standard — non un'eccezione.",
      pillars: [
        {
          label: "Trasparenza",
          desc: "Preventivi chiari, tempistiche reali, comunicazione costante.",
          icon: "shield",
        },
        {
          label: "Qualità",
          desc: "Codice pulito e design curato in ogni dettaglio, sempre.",
          icon: "sparkles",
        },
        {
          label: "Velocità",
          desc: "Ottimizziamo ogni sito per essere veloce e leggero.",
          icon: "zap",
        },
        {
          label: "Supporto",
          desc: "Resti sempre in contatto con chi lavora al tuo progetto.",
          icon: "headset",
        },
      ],
    },
    faq: {
      eyebrow: "DOMANDE FREQUENTI",
      title: "Risposte chiare, senza sorprese.",
      items: [
        {
          q: "Quanto tempo richiede un nuovo sito web?",
          a: "Dipende dalla complessità: una landing page richiede 2–3 settimane, un e-commerce completo 6–10 settimane. Ti forniamo sempre una roadmap dettagliata prima di iniziare.",
        },
        {
          q: "Quali sono i vostri prezzi?",
          a: "Ogni progetto è su misura: il prezzo viene definito in base a obiettivi, funzionalità e contenuti. Inviaci una richiesta e ricevi un preventivo trasparente entro 48 ore.",
        },
        {
          q: "Offrite assistenza dopo il lancio?",
          a: "Sì. Possiamo concordare un piano di manutenzione mensile con aggiornamenti, backup e supporto, oppure interventi puntuali quando ne hai bisogno.",
        },
        {
          q: "Potete lavorare con brand all'estero?",
          a: "Sì. La sede è in Germania e parliamo italiano, inglese e tedesco. Lavoriamo con clienti in tutta Europa.",
        },
        {
          q: "Chi si occupa dei contenuti (testi e immagini)?",
          a: "Possiamo aiutarti con copywriting e supporto creativo, oppure guidarti nel fornirci il materiale con brief e linee guida chiare.",
        },
      ],
    },
    ctaBanner: {
      title: "Pronto a far crescere il tuo brand online?",
      subtitle:
        "Raccontaci la tua idea: ti proporremo un percorso concreto, con tempi, costi e prossimi passi.",
      cta: "Iniziamo ora",
    },
    contact: {
      eyebrow: "INIZIAMO",
      title: "Parliamo del tuo prossimo progetto.",
      subtitle:
        "Compila il modulo o scansiona il QR code: ti risponderemo il prima possibile.",
      form: {
        name: "Nome e cognome",
        email: "Email",
        phone: "Telefono (opzionale)",
        service: "Servizio di interesse",
        servicePlaceholder: "Seleziona un servizio",
        message: "Raccontaci il tuo progetto",
        submit: "Invia richiesta",
        submitting: "Invio in corso...",
        success: "Messaggio inviato! Ti ricontatteremo al più presto.",
        error: "Qualcosa è andato storto. Riprova o scrivici a defalcowebsolution@outlook.com",
        privacy: "Inviando accetti la nostra informativa privacy.",
      },
      qr: {
        title: "Scansiona & contattaci",
        subtitle:
          "Inquadra il QR con lo smartphone per aprire il modulo di contatto.",
      },
    },
    footer: {
      tagline: "Innovate Your Future.",
      description:
        "DeFalco WebSolution — Web Design & Sviluppo Web con sede in Germania. Lavoriamo con clienti in tutta Europa.",
      navTitle: "Navigazione",
      contactTitle: "Contatti",
      legalTitle: "Legale",
      legal: { privacy: "Privacy Policy", cookies: "Cookie Policy", terms: "Termini" },
      rights: "Tutti i diritti riservati.",
      madeIn: "Progettato e sviluppato con cura.",
    },
    lang: { label: "Lingua", it: "IT", en: "EN", de: "DE" },
  },

  en: {
    nav: {
      services: "Services",
      process: "Process",
      work: "What we build",
      about: "About",
      contact: "Contact",
      cta: "Get a quote",
    },
    hero: {
      eyebrow: "WEB DESIGN AGENCY · INNOVATE YOUR FUTURE",
      titleLine1: "We craft",
      titleLine2: "digital experiences",
      titleLine3: "that matter.",
      subtitle:
        "DeFalco WebSolution turns ideas into elegant, fast websites built to grow your brand. Tailored design, clean code, attention to detail.",
      primaryCta: "Start your project",
      secondaryCta: "Explore services",
      scrollHint: "Scroll to explore",
      pillarsTitle: "Our approach",
      pillars: [
        { label: "Tailored design", desc: "No templates, only solutions made for you." },
        { label: "Clean code", desc: "Fast, secure, maintainable." },
        { label: "Real support", desc: "Direct and continuous communication." },
      ],
      tagsBelow: ["Multilingual", "Responsive", "SEO-friendly"],
    },
    marquee: [
      "WEB DESIGN",
      "DEVELOPMENT",
      "E-COMMERCE",
      "SEO",
      "BRANDING",
      "MAINTENANCE",
      "STRATEGY",
      "UX/UI",
    ],
    stack: {
      eyebrow: "OUR STACK",
      title: "Modern technology. Lasting results.",
      body:
        "We use proven tools and industry best practices to deliver speed, security and scalability.",
      groups: [
        { label: "Front-end", items: ["React", "Next.js", "Tailwind CSS", "Framer Motion"] },
        { label: "Back-end", items: ["Node.js", "FastAPI", "MongoDB", "PostgreSQL"] },
        { label: "Platforms", items: ["WordPress", "Shopify", "Webflow", "Sanity CMS"] },
        { label: "Quality", items: ["Web Vitals", "Technical SEO", "GDPR", "AA Accessibility"] },
      ],
    },
    services: {
      eyebrow: "WHAT WE DO",
      title: "Services designed to grow your business.",
      items: {
        webdesign: { title: "Web Design", description: "Elegant, intuitive interfaces crafted to turn visitors into customers." },
        development: { title: "Web Development", description: "Fast, secure and scalable websites built on modern technology." },
        ecommerce: { title: "E-commerce", description: "Performant online shops ready to sell anywhere, 24/7." },
        seo: { title: "SEO", description: "We work on technical optimization and content to improve your visibility on Google." },
        branding: { title: "Branding", description: "Consistent visual identities that tell who you are and what you do." },
        maintenance: { title: "Maintenance", description: "Updates, backups and ongoing support so you can rest easy." },
      },
    },
    process: {
      eyebrow: "HOW WE WORK",
      title: "A clear process, from first click to launch.",
      steps: [
        { title: "Listen", description: "We learn your goals, audience and the brand you want to build." },
        { title: "Strategy", description: "We define architecture, content and identity in a concrete plan." },
        { title: "Design", description: "Interactive prototypes that mirror your digital personality." },
        { title: "Development", description: "We build with clean, performant and accessible code." },
        { title: "Launch & Growth", description: "We publish, measure, optimize. Launch is only the beginning." },
      ],
    },
    work: {
      eyebrow: "WHAT WE CAN BUILD",
      title: "The kinds of websites we craft.",
      items: [
        { tag: "E-COMMERCE", name: "Online stores", desc: "Multilingual and multi-currency shops with shipping and payment integrations." },
        { tag: "CORPORATE", name: "Company websites", desc: "Professional presence, team section, news area, lead generation." },
        { tag: "PORTFOLIO", name: "Creative portfolios", desc: "For photographers, designers and studios that want to stand out." },
        { tag: "WEB APP", name: "Custom applications", desc: "Dashboards, internal tools, SaaS platforms, automations." },
      ],
      viewAll: "Let's talk",
    },
    why: {
      eyebrow: "OUR VALUES",
      title: "Digital partners, not just vendors.",
      body:
        "We work closely with every client. Transparency, attention to detail and real care are our standard — not an exception.",
      pillars: [
        { label: "Transparency", desc: "Clear quotes, real timelines, constant communication.", icon: "shield" },
        { label: "Quality", desc: "Clean code and careful design in every detail, always.", icon: "sparkles" },
        { label: "Speed", desc: "We optimize every website to be fast and lightweight.", icon: "zap" },
        { label: "Support", desc: "You always stay in touch with the person working on your project.", icon: "headset" },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Clear answers. No surprises.",
      items: [
        { q: "How long does a new website take?", a: "It depends on complexity: a landing page takes 2–3 weeks, a full e-commerce 6–10 weeks. We always share a detailed roadmap before starting." },
        { q: "How much do you charge?", a: "Every project is tailored: the price depends on goals, features and content. Send us a request and receive a transparent quote within 48 hours." },
        { q: "Do you offer post-launch support?", a: "Yes. We can agree on a monthly maintenance plan with updates, backups and support, or one-off interventions when you need them." },
        { q: "Can you work with international brands?", a: "Yes. We're based in Germany and speak Italian, English and German. We work with clients across Europe." },
        { q: "Who takes care of the content (copy and images)?", a: "We can help with copywriting and creative support, or guide you in providing materials through clear briefs and templates." },
      ],
    },
    ctaBanner: {
      title: "Ready to grow your brand online?",
      subtitle:
        "Tell us your idea: we'll propose a concrete path with timelines, costs and next steps.",
      cta: "Let's start now",
    },
    contact: {
      eyebrow: "LET'S START",
      title: "Let's talk about your next project.",
      subtitle:
        "Fill in the form or scan the QR code: we'll get back to you as soon as possible.",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        service: "Service of interest",
        servicePlaceholder: "Pick a service",
        message: "Tell us about your project",
        submit: "Send request",
        submitting: "Sending...",
        success: "Message sent! We'll reach out shortly.",
        error: "Something went wrong. Try again or write to defalcowebsolution@outlook.com",
        privacy: "By submitting you accept our privacy policy.",
      },
      qr: {
        title: "Scan & contact us",
        subtitle: "Point your smartphone at the QR to open the contact form.",
      },
    },
    footer: {
      tagline: "Innovate Your Future.",
      description:
        "DeFalco WebSolution — Web Design & Development based in Germany. We work with clients across Europe.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      legalTitle: "Legal",
      legal: { privacy: "Privacy Policy", cookies: "Cookie Policy", terms: "Terms" },
      rights: "All rights reserved.",
      madeIn: "Designed and built with care.",
    },
    lang: { label: "Language", it: "IT", en: "EN", de: "DE" },
  },

  de: {
    nav: {
      services: "Leistungen",
      process: "Prozess",
      work: "Was wir bauen",
      about: "Über uns",
      contact: "Kontakt",
      cta: "Angebot anfordern",
    },
    hero: {
      eyebrow: "WEB-DESIGN-AGENTUR · INNOVATE YOUR FUTURE",
      titleLine1: "Wir gestalten",
      titleLine2: "digitale Erlebnisse,",
      titleLine3: "die zählen.",
      subtitle:
        "DeFalco WebSolution verwandelt Ideen in elegante, schnelle Websites, die Ihre Marke wachsen lassen. Maßgeschneidertes Design, sauberer Code, Liebe zum Detail.",
      primaryCta: "Projekt starten",
      secondaryCta: "Leistungen entdecken",
      scrollHint: "Scrollen zum Erkunden",
      pillarsTitle: "Unser Ansatz",
      pillars: [
        { label: "Maßgeschneidertes Design", desc: "Keine Templates, nur Lösungen für Sie." },
        { label: "Sauberer Code", desc: "Schnell, sicher, wartbar." },
        { label: "Echter Support", desc: "Direkte und kontinuierliche Kommunikation." },
      ],
      tagsBelow: ["Mehrsprachig", "Responsive", "SEO-freundlich"],
    },
    marquee: [
      "WEB-DESIGN",
      "ENTWICKLUNG",
      "E-COMMERCE",
      "SEO",
      "BRANDING",
      "WARTUNG",
      "STRATEGIE",
      "UX/UI",
    ],
    stack: {
      eyebrow: "UNSER STACK",
      title: "Moderne Technologie. Dauerhafte Ergebnisse.",
      body:
        "Wir setzen auf bewährte Tools und Branchenstandards für Geschwindigkeit, Sicherheit und Skalierbarkeit.",
      groups: [
        { label: "Front-end", items: ["React", "Next.js", "Tailwind CSS", "Framer Motion"] },
        { label: "Back-end", items: ["Node.js", "FastAPI", "MongoDB", "PostgreSQL"] },
        { label: "Plattformen", items: ["WordPress", "Shopify", "Webflow", "Sanity CMS"] },
        { label: "Qualität", items: ["Web Vitals", "Technisches SEO", "DSGVO", "Barrierefreiheit AA"] },
      ],
    },
    services: {
      eyebrow: "WAS WIR TUN",
      title: "Leistungen, die Ihr Geschäft wachsen lassen.",
      items: {
        webdesign: { title: "Web-Design", description: "Elegante, intuitive Oberflächen, die Besucher in Kunden verwandeln." },
        development: { title: "Web-Entwicklung", description: "Schnelle, sichere und skalierbare Websites mit moderner Technologie." },
        ecommerce: { title: "E-Commerce", description: "Performante Online-Shops, die rund um die Uhr verkaufen." },
        seo: { title: "SEO", description: "Wir arbeiten an technischer Optimierung und Inhalten, um Ihre Sichtbarkeit bei Google zu verbessern." },
        branding: { title: "Branding", description: "Konsistente visuelle Identitäten, die Ihre Geschichte erzählen." },
        maintenance: { title: "Wartung", description: "Updates, Backups und laufender Support — damit Sie ruhig schlafen." },
      },
    },
    process: {
      eyebrow: "SO ARBEITEN WIR",
      title: "Ein klarer Prozess, vom ersten Klick bis zum Launch.",
      steps: [
        { title: "Zuhören", description: "Wir lernen Ihre Ziele, Zielgruppe und Ihre Markenpositionierung kennen." },
        { title: "Strategie", description: "Architektur, Inhalt und Identität — konkret geplant." },
        { title: "Design", description: "Interaktive Prototypen, die Ihre digitale Persönlichkeit widerspiegeln." },
        { title: "Entwicklung", description: "Sauberer, performanter und zugänglicher Code." },
        { title: "Launch & Wachstum", description: "Wir veröffentlichen, messen, optimieren. Der Launch ist erst der Anfang." },
      ],
    },
    work: {
      eyebrow: "WAS WIR BAUEN KÖNNEN",
      title: "Die Arten von Websites, die wir gestalten.",
      items: [
        { tag: "E-COMMERCE", name: "Online-Shops", desc: "Mehrsprachige und multi-währungsfähige Shops mit Versand- und Zahlungsintegrationen." },
        { tag: "CORPORATE", name: "Unternehmenswebsites", desc: "Professioneller Auftritt, Team-Bereich, News, Lead-Generierung." },
        { tag: "PORTFOLIO", name: "Kreative Portfolios", desc: "Für Fotografen, Designer und Studios, die sich abheben wollen." },
        { tag: "WEB APP", name: "Maßgeschneiderte Anwendungen", desc: "Dashboards, interne Tools, SaaS-Plattformen, Automatisierungen." },
      ],
      viewAll: "Sprechen wir darüber",
    },
    why: {
      eyebrow: "UNSERE WERTE",
      title: "Digitale Partner, nicht nur Lieferanten.",
      body:
        "Wir arbeiten eng mit jedem Kunden. Transparenz, Liebe zum Detail und echtes Interesse sind unser Standard — keine Ausnahme.",
      pillars: [
        { label: "Transparenz", desc: "Klare Angebote, realistische Zeitpläne, ständige Kommunikation.", icon: "shield" },
        { label: "Qualität", desc: "Sauberer Code und durchdachtes Design — immer.", icon: "sparkles" },
        { label: "Geschwindigkeit", desc: "Wir optimieren jede Website auf Schnelligkeit und Leichtigkeit.", icon: "zap" },
        { label: "Support", desc: "Sie bleiben immer im Kontakt mit der Person, die an Ihrem Projekt arbeitet.", icon: "headset" },
      ],
    },
    faq: {
      eyebrow: "HÄUFIGE FRAGEN",
      title: "Klare Antworten. Keine Überraschungen.",
      items: [
        { q: "Wie lange dauert eine neue Website?", a: "Je nach Komplexität: Eine Landingpage dauert 2–3 Wochen, ein vollständiger E-Commerce 6–10 Wochen. Vor Start erhalten Sie eine detaillierte Roadmap." },
        { q: "Was kostet ein Projekt?", a: "Jedes Projekt ist individuell: Der Preis richtet sich nach Zielen, Funktionen und Inhalten. Senden Sie eine Anfrage, innerhalb von 48 Stunden erhalten Sie ein transparentes Angebot." },
        { q: "Gibt es Support nach dem Launch?", a: "Ja. Wir können einen monatlichen Wartungsplan mit Updates, Backups und Support vereinbaren, oder einzelne Eingriffe nach Bedarf." },
        { q: "Arbeiten Sie auch international?", a: "Ja. Wir haben unseren Sitz in Deutschland und sprechen Italienisch, Englisch und Deutsch. Wir arbeiten mit Kunden in ganz Europa." },
        { q: "Wer kümmert sich um Inhalte (Texte, Bilder)?", a: "Wir helfen mit Copywriting und kreativer Unterstützung oder begleiten Sie bei der Bereitstellung von Materialien mit klaren Briefings." },
      ],
    },
    ctaBanner: {
      title: "Bereit, Ihre Marke online wachsen zu lassen?",
      subtitle:
        "Erzählen Sie uns Ihre Idee: Wir schlagen einen konkreten Weg vor mit Zeitrahmen, Kosten und nächsten Schritten.",
      cta: "Jetzt starten",
    },
    contact: {
      eyebrow: "LOS GEHT'S",
      title: "Sprechen wir über Ihr nächstes Projekt.",
      subtitle:
        "Füllen Sie das Formular aus oder scannen Sie den QR-Code: Wir melden uns so schnell wie möglich.",
      form: {
        name: "Vor- und Nachname",
        email: "E-Mail",
        phone: "Telefon (optional)",
        service: "Gewünschte Leistung",
        servicePlaceholder: "Leistung auswählen",
        message: "Erzählen Sie uns von Ihrem Projekt",
        submit: "Anfrage senden",
        submitting: "Wird gesendet...",
        success: "Nachricht gesendet! Wir melden uns in Kürze.",
        error: "Etwas ist schiefgelaufen. Versuchen Sie es erneut oder schreiben Sie an defalcowebsolution@outlook.com",
        privacy: "Mit dem Absenden akzeptieren Sie unsere Datenschutzerklärung.",
      },
      qr: {
        title: "Scannen & Kontakt",
        subtitle: "Richten Sie Ihr Smartphone auf den QR-Code, um das Formular zu öffnen.",
      },
    },
    footer: {
      tagline: "Innovate Your Future.",
      description:
        "DeFalco WebSolution — Web-Design & Entwicklung mit Sitz in Deutschland. Wir arbeiten europaweit.",
      navTitle: "Navigation",
      contactTitle: "Kontakt",
      legalTitle: "Rechtliches",
      legal: { privacy: "Datenschutz", cookies: "Cookies", terms: "AGB" },
      rights: "Alle Rechte vorbehalten.",
      madeIn: "Mit Sorgfalt gestaltet und entwickelt.",
    },
    lang: { label: "Sprache", it: "IT", en: "EN", de: "DE" },
  },
};

export const LANGUAGES = ["it", "en", "de"];
